import { makeStyles } from '@material-ui/styles';
import { gray, white } from '../../../constants/Colors';

const topPanelHeight = 60;
const menuFromTop = topPanelHeight + 1;

export default makeStyles((theme) => ({
    root: {},
    menuRoot: {
        position: 'fixed',
        width: '235px',
        maxHeight: `calc(100vh - ${menuFromTop}px)`,
        zIndex: '2',
        top: menuFromTop,
        left: '0',
        overflow: 'auto',
        backgroundColor: white,
        animationName: 'menuContentIn',
        animationDuration: '.28s',
        animationTimingFunction: 'cubic-bezier(.8,0,.2,1)',
        animationFillMode: 'backwards',
        animationDelay: '40ms',
    },
    backdrop: {
        top: topPanelHeight,
        backgroundColor: 'rgba(0, 0, 0, .3)',
    },
    activeArea: {
        display: 'flex',
        height: ({ isMenuHidden }) => (isMenuHidden ? 54 : 'auto'),
    },
    buttonContainer: {
        marginLeft: 8,
        paddingTop: 3,
    },
    menuButton: {
        paddingTop: 20,
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: ({ isMenuHidden }) => (isMenuHidden ? 54 : 7),
        marginTop: 4,
    },
    image: {
        height: '35px',
        content: theme?.common?.mainLogo?.paycorLogo ? `url(${theme?.common?.mainLogo?.paycorLogo})` : 'inherit',
    },
    closeIcon: {
        position: 'absolute',
        right: '15px',
        top: '10px',
        cursor: 'pointer',
    },
    menuItems: {
        display: 'flex',
        flexDirection: 'column',
    },
    employerSearchContainer: {
        marginLeft: '20px',
    },
    noResultsFound: {
        textAlign: 'center',
        padding: 20,
        color: gray,
    },
}));
